<template >
  <div class="mainbody">
    <h3 class="title">校友会信息</h3>
    <div class="aLine"></div>
    <div class="infobody">
      <div class="info_div">
        <span>名称：</span>
        <span>{{ info.title }}</span>
      </div>
      <div class="info_div">
        <span>联系人名称：</span>
        <span>{{ info.administrator }}</span>
      </div>
      <div style="clear: both"></div>
      <div class="info_div">
        <span>校友会公众号：</span>
        <span>{{ info.wechat }}</span>
      </div>
      <div class="info_div">
        <span>联系人微信：</span>
        <span>{{ info.admin_wechat }}</span>
      </div>
      <div style="clear: both"></div>
      <div class="info_div">
        <span>社群类型：</span>
        <span>{{ info.type }}</span>
      </div>
      <div class="info_div">
        <span>后台分类：</span>
        <span>{{ info.b_type }}</span>
      </div>
      <div style="clear: both"></div>
      <div class="tableInfo">
        <h3 class="title">简介信息</h3>
        <div class="aLine"></div>
        <p>{{ info.abstract }}</p>
      </div>
      <div class="tableInfo">
        <h3 class="title">Logo信息</h3>
        <div class="aLine"></div>
        <el-image
          class="imageDiv"
          style="margin-left: 8px"
          :src="infoThumb"
          fit="scale-down"
        >
          <div
            slot="error"
            class="image-slot"
            style="position: absolute; top: 50%; left: 50%"
          >
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";

export default {
  components: {},
  data() {
    return {
      infoThumb: "",
      info: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 获取详情
    getInfo: function () {
      this.$api
        .associationInfo({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
          this.info = data.Data;
          this.infoThumb = URL_PATH + this.info.thumb;
        })
        .catch(({ error }) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.infobody {
  margin: 32px;
}
.info_div {
  width: 300px;
  float: left;
  margin-bottom: 8px;
}
.info_div span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
}
.mainbody .tableInfo {
  margin-top: 24px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo p {
  padding: 16px 24px 67px 24px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.9);
  opacity: 0.72;
}
</style>



// WEBPACK FOOTER //
// src/components/association/associationDetails.vue